module.exports = __webpack_public_path__ + "static/media/radio.463809d6.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Icons/radio.svg
// module id = 876
// module chunks = 21